import React from "react";

const Dropdown = ({ options, id, selectedValue, onSelectedValueChange }) => {
  return (
    <div>
      <select id={id} onChange={(e) => onSelectedValueChange(e.target.value)}>
        {options.map(({ value, label }) => (
          <option value={value} selected={value === selectedValue}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
